// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconVip = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M5.844 15.208c-.294-.938-.602-1.918-.91-2.842L3.1 6.948H1.392v.574L4.766 17h2.142l3.5-9.478v-.574H8.77l-1.946 5.558c-.336.966-.574 1.764-.868 2.702zM11.578 17h1.764V6.948h-1.764zm5.391 0v-3.864h1.778c2.338 0 3.78-.98 3.78-3.08 0-1.75-.924-3.108-3.64-3.108h-3.668V17zm0-8.554h1.708c1.204 0 2.1.364 2.1 1.61 0 1.204-.91 1.582-2.128 1.582h-1.68z" />
  );
export default SvgIconVip;
